import { render, staticRenderFns } from "./PerformDetail.vue?vue&type=template&id=529682b1&scoped=true&"
import script from "./PerformDetail.vue?vue&type=script&lang=js&"
export * from "./PerformDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529682b1",
  null
  
)

export default component.exports